export default {
  getHotLine: '/v3/config/courier/hotline',
  // queryDetailInfo: '/v3/mine/queryDetailInfo', //闪送员信息
  queryMobileInfo: '/v3/couriers/mobile' // 闪送员手机号
}
